import { get } from './api-helper';

/**
 * Accounts resource helper to request accounts info.
 * @returns {RequestResult} - result of api call.
 */
export const getAccounts = async (params) => {
  return get(`/accounts`, params);
};
